export enum Products {
    unknown = 0,
    checkpoint_trader = 1,
    dark_money_indicator = 2,
    deep_market_trader = 3,
    freemium = 4,
    monthly_trend_trader = 5,
    options_soup = 6,
    profit_skimmer = 7,
    public = 8,
    sector_focus = 9,
    sector_prophets_elite = 10,
    sector_prophets_lite = 11,
    sector_prophets_pro = 12,
    technical_analysis_millionaire = 13,
    true_market_insiders = 14,
    true_sovereign_profits = 15,
    tycoon = 16,
    sector_prophets = 17,
    transformity_investor = 18,
    transformity_wealth = 19,
    mega_trend_profit_club = 20,
    small_cap_cash_cows = 21
}
